import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { find } from 'lodash';
import { FieldTypes, parseSelectOptions } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const GrammatechCodeSonarMappingForm = forwardRef(function GrammatechCodeSonarMappingForm(props, ref) {
    const [projects, setProjects] = useState(() => {
      if (props.record) {
        const { applicationId, applicationName } = props.record;
        return [{id: applicationId, name: applicationName}]
      }
      return [];
    });

    useEffect(() => {
      const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
      promise.then((response) => {
        const { projects } = response;
        setProjects(projects);
      }).catch(() => {
        message.error('Problem fetching projects');
      });
  
      return cancel;
    }, [props.loginConfigId,props.toolName]);
  
    const getExtraFieldsData = useCallback((config) => {
      const { applicationId } = config;
      const applicationName = find(projects, (obj) => obj.id === applicationId)?.name;
  
      return ({
        applicationId,
        applicationName,
      });
    }, [projects])
  
    const extraFields = useMemo(() => ([
      {
        name: 'applicationId',
        colSpan: '12',
        type: FieldTypes.SELECT,
        label: props.toolName + ' Application',
        options: parseSelectOptions(projects),
        rules: [{ required: true, message: `${props.toolName} Application is required` }],
        props: {
          autoFocus: true
        }
      }
    ]), [projects, props.toolName]);
  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      title={`Map ${props.toolName} Application`}
      {...props}
    />
  )
})

export default GrammatechCodeSonarMappingForm;
